import axios from 'axios';
import LocalStorage from '../../const/LocalStorage';

export default {
  getCustomer
};

const GET_CUSTOMER = 'backoffice/api/v1/customer';

function getCustomer(username) {
  const adLoginCallcenterStorage = localStorage.getItem(LocalStorage.AD_LOGIN_CALLCENTER);
  const adLoginCallcenter = adLoginCallcenterStorage ? JSON.parse(adLoginCallcenterStorage) : null;

  var headers = {
    username: username,
    Authorization: adLoginCallcenter && adLoginCallcenter.accessToken ? `Bearer ${adLoginCallcenter.accessToken}` : null
  };

  return new Promise((resolve, reject) => {
    axios
      .get(GET_CUSTOMER, { headers: headers })
      .then(res => resolve(res))
      .catch(reject);
  });
}



// WEBPACK FOOTER //
// ./src/services/backofficeCustomer/BackofficeCustomerService.js